import moment from 'moment'
import { IShipmentStopTypes, Maybe } from 'types/graphqlTypes'
import { IFacilityHourFragment } from 'apps/marketplace/graphql/FacilityHourFragment'
import { findScheduleByDate } from './findScheduleByDate'

interface IIsFacilityOpenAtTimeProps {
  date: Maybe<string>
  time: Maybe<string>
  stopType: Maybe<IShipmentStopTypes>
  scheduleHours: Maybe<IFacilityHourFragment[]>
}

/**
 * Returns true if selected date and time is found within schedule
 * @example isFacilityOpenAtTime({ date: '2022-02-21', time: '13:00', stopType: 'pickup', scheduleHours: []}) // false
 */
export const isFacilityOpenAtTime = ({
  date,
  scheduleHours,
  stopType,
  time,
}: IIsFacilityOpenAtTimeProps): boolean => {
  const isValidData = !!date && !!time && !!stopType && !!scheduleHours
  if (!isValidData) {
    return false
  }

  const startTime = moment(time, 'h:mm')
  const scheduleDay = findScheduleByDate({ date, stopType, scheduleHours })

  if (!scheduleDay) {
    return false
  }

  const open = moment(scheduleDay.startTime, 'h:mm')
  const close = moment(scheduleDay.endTime, 'h:mm')

  if (startTime.isValid() && open.isValid() && close.isValid()) {
    return startTime.isBetween(open, close, 'minute', '[]')
  }
  return false
}
